<template>
  <div>
    <div class="upload-tips-wrappers">
      <p class="mb-1">{{ $l('tips_label_custLogo_1') || '操作提示：' }}</p>
      <p>
        {{
          $l('tips_label_custLogo_2') ||
            '1、请上传客户LOGO图片，建议上传 300px*300px PNG格式图片'
        }}
      </p>
      <p>{{ $l('tips_label_custLogo_3') || '2、LOGO图片大小不超过5M' }}</p>
    </div>

    <div class="logo-uploader mb-2 mt-4">
      <div>
        <div
          class="logo-image logo-origin-image"
          :class="{ upload: !v_bigImageUrl }"
          @click="() => (!v_bigImageUrl ? uploadFile() : () => {})"
        >
          <div class="upload-active" v-if="!v_bigImageUrl">
            <i class="el-icon-plus" />
            <div class="mt-2">{{ $l('btn_uploadLogo') || '点击上传图片' }}</div>
          </div>

          <div v-if="v_bigImageUrl">
            <el-image
              ref="originImage"
              :src="v_bigImageUrl"
              fit="contain"
              :preview-src-list="[v_bigImageUrl]"
              style="width:100%;height: 100%;"
            />
            <div class="upload-opts">
              <span @click="$refs.originImage.clickHandler()">
                <i class="el-icon-zoom-in" />
              </span>
              <span @click="uploadFile()" class="ml-2">
                <i class="el-icon-plus" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="logo-image logo-small-image">
          <el-image
            v-if="v_middleImageUrl"
            :src="v_middleImageUrl"
            :preview-src-list="[v_middleImageUrl]"
            fit="contain"
            style="width:100%;height: 100%;"
          />
        </div>
        <div class="image-spec">
          {{ $l('form_label_middleLogo') || '150x150px' }}
        </div>
      </div>
      <div>
        <div class="logo-image logo-mini-image">
          <el-image
            v-if="v_smallImageUrl"
            :src="v_smallImageUrl"
            :preview-src-list="[v_smallImageUrl]"
            fit="contain"
            style="width:100%;height: 100%;"
          />
        </div>
        <div class="image-spec">
          {{ $l('form_label_smallLogo') || '60x60px' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VXETable } from 'vxe-table'
import Compressor from 'compressorjs'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    bigImageUrl: { type: String, default: '' },
    middleImageUrl: { type: String, default: '' },
    smallImageUrl: { type: String, default: '' },
  },
  data() {
    return {
      v_bigImageUrl: '',
      v_middleImageUrl: '',
      v_smallImageUrl: '',
      uploadResult: {},
    }
  },
  mounted() {
    this.v_bigImageUrl = this.bigImageUrl
    this.v_middleImageUrl = this.middleImageUrl
    this.v_smallImageUrl = this.smallImageUrl
  },
  methods: {
    async uploadFile() {
      const { file } = await VXETable.readFile({
        types: ['png', 'PNG'],
      }).catch(() => ({}))
      if (!file) return

      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error(
          this.$l('tips_error_uploadCustLogo_big_5mb') ||
            '上传LOGO大小不能超过 5MB!'
        )
        return
      }

      if (this.loadingOpen()) return
      const middleImage = await new Promise((resolve) => {
        new Compressor(file, {
          width: 150,
          height: 150,
          resize: 'contain',
          quality: 1,
          success: (result) => resolve(new File([result], result.name)),
          error: () => resolve(),
        })
      })
      const smallImage = await new Promise((resolve) => {
        new Compressor(file, {
          width: 60,
          height: 60,
          resize: 'contain',
          quality: 1,
          success: (result) => resolve(new File([result], result.name)),
          error: () => resolve(),
        })
      })

      if (!middleImage || !smallImage) {
        this.loadingClose()
        this.$message.error(
          this.$l('tips_error_uploadCustLogo_compressor') ||
            '压缩LOGO失败，无法上传!'
        )
        return
      }

      const uploadTask = [file, middleImage, smallImage].map((file) => {
        return this.$api
          .SYS_UPLOAD(file)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
          }))
          .catch(() => null)
      })
      const files = await Promise.all(uploadTask)
      this.loadingClose()

      if (files.includes(null)) {
        this.$message.error(
          this.$l('tips_error_uploadCustLogo') || '文件上传失败，请联系管理员!'
        )
        return
      }

      const [
        { fileCode: bigImageCode, fileUrl: bigImageUrl },
        { fileCode: middleImageCode, fileUrl: middleImageUrl },
        { fileCode: smallImageCode, fileUrl: smallImageUrl },
      ] = files

      this.uploadResult = {
        bigImageCode,
        bigImageUrl,
        middleImageCode,
        middleImageUrl,
        smallImageCode,
        smallImageUrl,
      }

      this.v_bigImageUrl = bigImageUrl
      this.v_middleImageUrl = middleImageUrl
      this.v_smallImageUrl = smallImageUrl
    },
    save() {
      if (this.uploadResult.bigImageCode) {
        this.$emit('change', this.uploadResult)
      }
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-tips-wrappers {
  background-color: #fff6f7;
  border-radius: 4px;
  border-left: 4px solid #fe6c6f;
  padding: 10px;
  line-height: 1.5;
  color: #101010;
  font-size: 15px;
  p {
    margin: 0;
  }
}

.logo-uploader {
  display: flex;
  --origin-image-size: 300px;
  --small-image-size: 150px;
  --mini-image-size: 60px;
  > div {
    margin-right: auto;
    .image-spec {
      color: rgba(0, 0, 0, 0.4);
      font-size: 12px;
      text-align: center;
      margin-top: 10px;
    }
  }
  .logo-image {
    border-radius: 4px;
    border: 1px dashed #dcdcdc;
    background-color: #eeeeee;
    position: relative;
  }

  .logo-origin-image {
    width: var(--origin-image-size);
    height: var(--origin-image-size);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;

    .upload-active {
      display: none;
      .el-icon-plus {
        font-size: 22px;
      }
    }
    &:hover {
      .upload-opts {
        opacity: 1;
      }
    }
    .upload-opts {
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 0;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 30px;

      [class^='el-icon'] {
        cursor: pointer;
      }
    }
  }
  .logo-origin-image.upload {
    &:hover {
      color: #409eff !important;
      border-color: #409eff;
    }
    .upload-active {
      display: block;
    }
  }

  .logo-small-image {
    width: var(--small-image-size);
    height: var(--small-image-size);
  }
  .logo-mini-image {
    width: var(--mini-image-size);
    height: var(--mini-image-size);
  }
}

// logo-uploader-image

// .logo-uploader .el-upload {
//   border: 1px dashed #d9d9d9;
//   border-radius: 6px;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
// }
// .logo-uploader .el-upload:hover {
//   border-color: #409eff;
// }
// .logo-uploader-icon {
//   font-size: 28px;
//   color: #8c939d;
//   width: 178px;
//   height: 178px;
//   line-height: 178px;
//   text-align: center;
// }
// .logo {
//   width: 178px;
//   height: 178px;
//   display: block;
// }
</style>
